/* reel-carousel.js — v5 No-Product Clean — Upload to Shopify Assets */
function initReelCarousel() {
(function () {
  'use strict';

  /* ===== SVG ICONS ===== */
  var SVG_VOL_ON  = '<path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07" stroke="white" stroke-width="1.5" fill="none" stroke-linecap="round"/>';
  var SVG_VOL_OFF = '<path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15" stroke="white" stroke-width="1.5" stroke-linecap="round"/><line x1="17" y1="9" x2="23" y2="15" stroke="white" stroke-width="1.5" stroke-linecap="round"/>';
  var SVG_PLAY    = '<polygon points="5,3 19,12 5,21" fill="white"/>';
  var SVG_PAUSE   = '<rect x="6" y="4" width="4" height="16" fill="white"/><rect x="14" y="4" width="4" height="16" fill="white"/>';

  /* ===== STATE ===== */
  var globalMuted      = true;
  var activeUnmutedCard = null;
  var currentPage      = 0;
  var cardWidth        = 0;
  var visibleCount     = 4;
  var maxPage          = 0;
  var isAnimating      = false;
  var CLONE_COUNT      = 6;
  var GAP              = 16;
  var sectionVisible   = false;
  var activeProg       = null;

  /* Mobile modal */
  var mReelIndex  = 0;
  var mSlides     = [];
  var mRafProg    = null;
  var hintShown   = false;
  var mSwipeDir   = null;
  var mSwiping    = false;
  var mTouchY0    = 0;
  var mTouchX0    = 0;

  /* ===== DOM ===== */
  var track          = document.getElementById('reelTrack');
  var outer          = document.getElementById('reelTrackOuter');
  var dotsWrap       = document.getElementById('reelDots');
  var btnPrev        = document.getElementById('reelPrev');
  var btnNext        = document.getElementById('reelNext');
  var modal          = document.getElementById('reelModal');
  var modalInner     = document.getElementById('reelModalInner');
  var modalVideo     = document.getElementById('modalVideo');
  var modalStack     = document.getElementById('modalStack');
  var modalClose     = document.getElementById('modalClose');
  var modalMuteBtn   = document.getElementById('modalMuteBtn');
  var modalMuteIcon  = document.getElementById('modalMuteIcon');
  var modalPlayPause = document.getElementById('modalPlayPause');
  var modalPlayIcon  = document.getElementById('modalPlayIcon');
  var modalTitle     = document.getElementById('modalTitle');
  var modalSub       = document.getElementById('modalSub');
  var modalTag       = document.getElementById('modalTag');
  var modalProgress  = document.getElementById('modalProgress');
  var modalProgFill  = document.getElementById('modalProgressFill');
  var swipeHint      = document.getElementById('swipeHint');

  if (!track) return;

  /* ===== READ REAL CARDS ===== */
  var realCards = Array.from(track.querySelectorAll('.reel-card:not(.reel-clone)'));
  var total     = realCards.length;
  if (total === 0) return;

  var reelData = realCards.map(function(c) {
    return {
      src:   c.dataset.src   || '',
      thumb: c.dataset.thumb || '',
      title: c.dataset.title || '',
      sub:   c.dataset.sub   || '',
      tag:   c.dataset.tag   || ''
    };
  });

  /* ===== CLONE BUILD ===== */
  function buildClones() {
    /* Prepend clones (end of list) */
    for (var i = CLONE_COUNT - 1; i >= 0; i--) {
      var srcIdx = (total - CLONE_COUNT + i + total) % total;
      var clone  = realCards[srcIdx].cloneNode(true);
      clone.classList.add('reel-clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.realIndex = srcIdx;
      var cv = clone.querySelector('.reel-card__video');
      if (cv) { cv.removeAttribute('src'); cv.removeAttribute('data-loaded'); }
      bindCardEvents(clone, srcIdx);
      track.insertBefore(clone, track.firstChild);
    }
    /* Append clones (start of list) */
    for (var j = 0; j < CLONE_COUNT; j++) {
      var srcIdx2 = j % total;
      var clone2  = realCards[srcIdx2].cloneNode(true);
      clone2.classList.add('reel-clone');
      clone2.setAttribute('aria-hidden', 'true');
      clone2.dataset.realIndex = srcIdx2;
      var cv2 = clone2.querySelector('.reel-card__video');
      if (cv2) { cv2.removeAttribute('src'); cv2.removeAttribute('data-loaded'); }
      bindCardEvents(clone2, srcIdx2);
      track.appendChild(clone2);
    }
  }

  var allCards = [];
  function refreshAllCards() {
    allCards = Array.from(track.querySelectorAll('.reel-card'));
  }

  /* ===== CARD EVENTS ===== */
  function bindCardEvents(card, realIdx) {
    var mb = card.querySelector('.reel-card__mute');
    var eb = card.querySelector('.reel-card__expand');

    if (mb) mb.addEventListener('click', function(e) {
      e.stopPropagation();
      toggleCardMute(card);
    });

    if (eb) eb.addEventListener('click', function(e) {
      e.stopPropagation();
      openModal(realIdx);
    });

    card.addEventListener('click', function(e) {
      if (mb && mb.contains(e.target)) return;
      if (eb && eb.contains(e.target)) return;
      var v  = card.querySelector('.reel-card__video');
      var pi = card.querySelector('.reel-card__play-icon');
      if (!v) return;
      if (v.paused) {
        stopAll();
        playCard(card);
      } else {
        v.pause();
        if (pi) pi.classList.remove('hide');
        card.classList.remove('is-active');
      }
    });
  }

  realCards.forEach(function(card, idx) { bindCardEvents(card, idx); });

  /* ===== MEASURE ===== */
  function measure() {
    var w = window.innerWidth;
    if      (w >= 1200) visibleCount = 5;
    else if (w >= 900)  visibleCount = 4;
    else if (w >= 600)  visibleCount = 3;
    else                visibleCount = 2;
    /* Read actual rendered card width — accurate after layout */
    var firstCard = allCards.find(function(c) { return !c.classList.contains('reel-clone'); }) || allCards[0];
    cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 200;
    maxPage   = Math.max(0, total - visibleCount);
  }

  /* ===== TRANSFORMS ===== */
  function getX(page) {
    return -((page + CLONE_COUNT) * (cardWidth + GAP));
  }

  function applyTransform(x, animated) {
    track.style.transition = animated
      ? 'transform 0.44s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
      : 'none';
    track.style.transform = 'translateX(' + x + 'px)';
  }

  /* ===== NAVIGATION ===== */
  function goTo(page, animated) {
    if (typeof animated === 'undefined') animated = true;
    currentPage = ((page % total) + total) % total;
    applyTransform(getX(currentPage), animated);
    updateDots();
  }

  function goNext() {
    if (isAnimating) return;
    isAnimating = true;
    var animToPage = currentPage + 1;
    applyTransform(getX(animToPage), true);

    var handled = false;
    function onEnd() {
      if (handled) return;
      handled = true;
      track.removeEventListener('transitionend', onEnd);
      if (animToPage >= total) {
        currentPage = 0;
        applyTransform(getX(0), false);
        /* Force reflow to prevent flash */
        void track.offsetWidth;
      } else {
        currentPage = animToPage;
      }
      updateDots();
      if (sectionVisible) ensureAllPlaying();
      isAnimating = false;
    }
    track.addEventListener('transitionend', onEnd);
    /* Safety fallback if transitionend doesn't fire */
    setTimeout(function() { onEnd(); }, 500);
  }

  function goPrev() {
    if (isAnimating) return;
    isAnimating = true;
    var animToPage = currentPage - 1;
    applyTransform(getX(animToPage), true);

    var handled = false;
    function onEnd() {
      if (handled) return;
      handled = true;
      track.removeEventListener('transitionend', onEnd);
      if (animToPage < 0) {
        currentPage = total - 1;
        applyTransform(getX(total - 1), false);
        void track.offsetWidth;
      } else {
        currentPage = animToPage;
      }
      updateDots();
      if (sectionVisible) ensureAllPlaying();
      isAnimating = false;
    }
    track.addEventListener('transitionend', onEnd);
    setTimeout(function() { onEnd(); }, 500);
  }

  /* ===== DOTS ===== */
  function renderDots() {
    dotsWrap.innerHTML = '';
    var pageCount = maxPage + 1;
    for (var i = 0; i < pageCount; i++) {
      (function(i) {
        var dot = document.createElement('button');
        dot.className = 'reel-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to reel ' + (i + 1));
        dot.addEventListener('click', function() { goTo(i); });
        dotsWrap.appendChild(dot);
      })(i);
    }
  }

  function updateDots() {
    var dots = dotsWrap.querySelectorAll('.reel-dot');
    var p    = ((currentPage % (maxPage + 1)) + (maxPage + 1)) % (maxPage + 1);
    dots.forEach(function(d, i) { d.classList.toggle('active', i === p); });
  }

  /* ===== STOP ALL ===== */
  function stopAll() {
    allCards.forEach(function(card) {
      var v  = card.querySelector('.reel-card__video');
      var t  = card.querySelector('.reel-card__thumb');
      var pi = card.querySelector('.reel-card__play-icon');
      if (!v) return;
      v.pause();
      if (t)  t.classList.remove('hidden');
      if (pi) pi.classList.remove('hide');
      card.classList.remove('is-active');
    });
    if (activeProg) { cancelAnimationFrame(activeProg); activeProg = null; }
  }

  /* ===== PLAY CARD ===== */
  function playCard(card) {
    var v  = card.querySelector('.reel-card__video');
    var t  = card.querySelector('.reel-card__thumb');
    var pi = card.querySelector('.reel-card__play-icon');
    var pf = card.querySelector('.reel-card__progress-fill');
    if (!v) return;
    var src = card.dataset.src;
    if (!src) return;

    /* Lazy-load src */
    if (v.getAttribute('data-loaded') !== src) {
      v.removeAttribute('src');
      v.src = src;
      v.setAttribute('data-loaded', src);
      v.muted = true;
      v.load();
    }

    v.muted       = (activeUnmutedCard === card) ? false : true;
    v.loop        = true;
    v.playsInline = true;

    /* Loop fallback for Android */
    if (!v._loopBound) {
      v._loopBound = true;
      v.addEventListener('ended', function() {
        if (card.classList.contains('is-active')) {
          v.currentTime = 0;
          v.play().catch(function() {});
        }
      });
    }

    function doPlay() {
      var p = v.play();
      if (p !== undefined) {
        p.then(function() {
          v.classList.add('playing');
          if (t)  t.classList.add('hidden');
          if (pi) pi.classList.add('hide');
          card.classList.add('is-active');
          tickProg(v, pf);
        }).catch(function() {
          if (pi) pi.classList.remove('hide');
        });
      }
    }

    if (v.readyState >= 3) {
      doPlay();
    } else {
      if (v._playHandler) v.removeEventListener('canplay', v._playHandler);
      v._playHandler = function() { doPlay(); };
      v.addEventListener('canplay', v._playHandler, { once: true });
    }
  }

  function tickProg(video, fill) {
    if (activeProg) cancelAnimationFrame(activeProg);
    (function step() {
      if (fill && !video.paused && video.duration) {
        fill.style.width = (video.currentTime / video.duration * 100) + '%';
      }
      activeProg = requestAnimationFrame(step);
    })();
  }

  /* ===== ENSURE ALL PLAYING (after navigation) ===== */
  function ensureAllPlaying() {
    if (!sectionVisible) return;
    realCards.forEach(function(card) {
      var v  = card.querySelector('.reel-card__video');
      var t  = card.querySelector('.reel-card__thumb');
      var pi = card.querySelector('.reel-card__play-icon');
      if (!v || !card.dataset.src) return;

      v.muted = (activeUnmutedCard === card) ? false : true;
      v.loop  = true;

      if (v.getAttribute('data-loaded') !== card.dataset.src) {
        v.src = card.dataset.src;
        v.setAttribute('data-loaded', card.dataset.src);
        v.load();
      }

      if (v.paused) {
        v.play().then(function() {
          v.classList.add('playing');
          if (t)  t.classList.add('hidden');
          if (pi) pi.classList.add('hide');
        }).catch(function() {
          v.load();
          setTimeout(function() {
            v.play().then(function() {
              v.classList.add('playing');
              if (t)  t.classList.add('hidden');
              if (pi) pi.classList.add('hide');
            }).catch(function() {});
          }, 300);
        });
      }
    });
    updateAllMuteIcons();
  }

  /* ===== AUTO PLAY ALL VISIBLE ===== */
  function autoPlayVisible() {
    if (!sectionVisible) return;
    realCards.forEach(function(card) {
      var v  = card.querySelector('.reel-card__video');
      var t  = card.querySelector('.reel-card__thumb');
      var pi = card.querySelector('.reel-card__play-icon');
      if (!v || !card.dataset.src) return;

      /* Skip already playing */
      if (!v.paused && v.getAttribute('data-loaded') === card.dataset.src) return;

      v.muted        = (activeUnmutedCard === card) ? false : true;
      v.loop         = true;
      v.playsInline  = true;

      if (v.getAttribute('data-loaded') !== card.dataset.src) {
        v.src = card.dataset.src;
        v.setAttribute('data-loaded', card.dataset.src);
        v.load();
      }

      var fired = false;
      function doPlay() {
        if (fired) return; fired = true;
        v.removeEventListener('loadeddata', doPlay);
        v.muted = (activeUnmutedCard === card) ? false : true;
        v.play().then(function() {
          v.classList.add('playing');
          if (t)  t.classList.add('hidden');
          if (pi) pi.classList.add('hide');
        }).catch(function() {});
      }

      if (v.readyState >= 3) {
        doPlay();
      } else {
        v.addEventListener('loadeddata', doPlay, { once: true });
        /* Fallback timeout */
        setTimeout(function() {
          if (!fired) {
            fired = true;
            v.play().then(function() {
              v.classList.add('playing');
              if (t) t.classList.add('hidden');
              if (pi) pi.classList.add('hide');
            }).catch(function() {});
          }
        }, 1500);
      }
    });
    updateAllMuteIcons();
  }

  /* ===== MUTE MANAGEMENT ===== */
  function updateAllMuteIcons() {
    allCards.forEach(function(c) {
      var mb = c.querySelector('.reel-card__mute svg');
      if (!mb) return;
      var v = c.querySelector('.reel-card__video');
      mb.innerHTML = (v && !v.muted) ? SVG_VOL_ON : SVG_VOL_OFF;
    });
    if (modalMuteIcon) modalMuteIcon.innerHTML = globalMuted ? SVG_VOL_OFF : SVG_VOL_ON;
  }

  function toggleCardMute(card) {
    var v  = card.querySelector('.reel-card__video');
    var mb = card.querySelector('.reel-card__mute svg');
    if (!v) return;

    if (v.muted) {
      /* Mute all first */
      allCards.forEach(function(c) {
        var cv  = c.querySelector('.reel-card__video');
        var cmb = c.querySelector('.reel-card__mute svg');
        if (cv)  cv.muted = true;
        if (cmb) cmb.innerHTML = SVG_VOL_OFF;
      });
      /* Unmute only this card */
      v.muted = false;
      if (mb) mb.innerHTML = SVG_VOL_ON;
      activeUnmutedCard = card;
      globalMuted = false;
    } else {
      v.muted = true;
      if (mb) mb.innerHTML = SVG_VOL_OFF;
      activeUnmutedCard = null;
      globalMuted = true;
    }

    /* Sync modal */
    if (modalVideo) modalVideo.muted = globalMuted;
    mSlides.forEach(function(s) { if (s.video) s.video.muted = globalMuted; });
  }

  function toggleGlobalMute() {
    globalMuted = !globalMuted;
    if (modalVideo) modalVideo.muted = globalMuted;
    mSlides.forEach(function(s) { if (s.video) s.video.muted = globalMuted; });
    if (modalMuteIcon) modalMuteIcon.innerHTML = globalMuted ? SVG_VOL_OFF : SVG_VOL_ON;
  }

  /* ===== DRAG / SWIPE on carousel ===== */
  var dragX = 0, dragStartX = 0, dragging = false, dragMoved = false;
  var touchX0 = 0, touchY0 = 0, cTouchDir = null;

  outer.addEventListener('mousedown', function(e) {
    dragging = true; dragMoved = false;
    dragX = e.clientX; dragStartX = e.clientX;
    outer.style.cursor = 'grabbing';
  });

  document.addEventListener('mousemove', function(e) {
    if (!dragging) return;
    if (Math.abs(e.clientX - dragStartX) > 8) dragMoved = true;
  });

  document.addEventListener('mouseup', function(e) {
    if (!dragging) return;
    dragging = false;
    outer.style.cursor = 'grab';
    if (!dragMoved) return;
    var diff = dragStartX - e.clientX;
    if      (diff > 40) goNext();
    else if (diff < -40) goPrev();
  });

  outer.addEventListener('touchstart', function(e) {
    touchX0 = e.touches[0].clientX;
    touchY0 = e.touches[0].clientY;
    cTouchDir = null;
  }, { passive: true });

  outer.addEventListener('touchmove', function(e) {
    if (!cTouchDir) {
      var dx = Math.abs(e.touches[0].clientX - touchX0);
      var dy = Math.abs(e.touches[0].clientY - touchY0);
      cTouchDir = dx > dy ? 'h' : 'v';
    }
    if (cTouchDir === 'h') e.preventDefault();
  }, { passive: false });

  outer.addEventListener('touchend', function(e) {
    if (cTouchDir !== 'h') return;
    var diff = touchX0 - e.changedTouches[0].clientX;
    if      (diff > 40) goNext();
    else if (diff < -40) goPrev();
  }, { passive: true });

  if (btnPrev) btnPrev.addEventListener('click', goPrev);
  if (btnNext) btnNext.addEventListener('click', goNext);

  /* ===== MODAL ===== */
  function isMobile() { return window.innerWidth <= 768; }

  function openModal(reelIdx) {
    /* Pause all background cards */
    allCards.forEach(function(c) {
      var v = c.querySelector('.reel-card__video');
      if (v && !v.paused) v.pause();
    });

    modal.classList.add('open');
    document.body.style.overflow = 'hidden';

    if (isMobile()) {
      buildMobileStack(reelIdx);
      if (!hintShown) {
        hintShown = true;
        if (swipeHint) {
          swipeHint.classList.add('show');
          setTimeout(function() { swipeHint.classList.remove('show'); }, 2400);
        }
      }
    } else {
      /* Desktop: play video in existing modal structure */
      var d = reelData[reelIdx];
      if (!d) return;

      if (modalVideo) {
        modalVideo.src = d.src;
        modalVideo.muted = globalMuted;
        modalVideo.loop = true;
        modalVideo.load();
        modalVideo.addEventListener('canplay', function onCan() {
          modalVideo.removeEventListener('canplay', onCan);
          modalVideo.play().catch(function() {});
          if (modalPlayIcon) modalPlayIcon.innerHTML = SVG_PAUSE;
        });
        modalVideo.addEventListener('timeupdate', onDesktopProg);
      }

      if (modalTag)   modalTag.textContent   = d.tag   || '';
      if (modalTitle) modalTitle.textContent = d.title || '';
      if (modalSub)   modalSub.textContent   = d.sub   || '';
      if (modalMuteIcon) modalMuteIcon.innerHTML = globalMuted ? SVG_VOL_OFF : SVG_VOL_ON;
      if (modalPlayIcon) modalPlayIcon.innerHTML = SVG_PLAY;
      if (modalProgFill) modalProgFill.style.width = '0%';
    }
  }

  function onDesktopProg() {
    if (modalVideo && modalVideo.duration && modalProgFill) {
      modalProgFill.style.width = (modalVideo.currentTime / modalVideo.duration * 100) + '%';
    }
  }

  function updateDesktopPlayIcon() {
    if (!modalVideo || !modalPlayIcon) return;
    modalPlayIcon.innerHTML = modalVideo.paused ? SVG_PLAY : SVG_PAUSE;
  }

  function closeModal() {
    modal.classList.remove('open');
    document.body.style.overflow = '';

    /* Stop desktop video */
    if (modalVideo) {
      modalVideo.pause();
      modalVideo.removeEventListener('timeupdate', onDesktopProg);
      try { modalVideo.src = ''; } catch(e) {}
    }
    if (modalProgFill) modalProgFill.style.width = '0%';
    if (modalPlayIcon) modalPlayIcon.innerHTML = SVG_PLAY;

    /* Clean mobile stack */
    mSlides.forEach(function(s) {
      if (s.video) {
        s.video.pause();
        try { s.video.src = ''; } catch(e) {}
      }
    });
    if (modalStack) modalStack.innerHTML = '';
    mSlides = [];
    if (mRafProg) { cancelAnimationFrame(mRafProg); mRafProg = null; }

    /* Resume background videos */
    if (sectionVisible) {
      realCards.forEach(function(card) {
        var v = card.querySelector('.reel-card__video');
        if (v && v.getAttribute('data-loaded') && v.paused) {
          v.play().catch(function() {});
        }
      });
    }
  }

  /* Close button & backdrop */
  if (modalClose)   modalClose.addEventListener('click', closeModal);
  if (modal)        modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
  if (modalMuteBtn) modalMuteBtn.addEventListener('click', toggleGlobalMute);

  if (modalPlayPause) {
    modalPlayPause.addEventListener('click', function() {
      if (isMobile()) {
        var center = mSlides[1]; if (!center || !center.video) return;
        if (center.video.paused) center.video.play().catch(function() {});
        else center.video.pause();
        if (modalPlayIcon) modalPlayIcon.innerHTML = center.video.paused ? SVG_PLAY : SVG_PAUSE;
      } else {
        if (!modalVideo) return;
        if (modalVideo.paused) modalVideo.play().catch(function() {});
        else modalVideo.pause();
        updateDesktopPlayIcon();
      }
    });
  }

  if (modalVideo) {
    modalVideo.addEventListener('play',  updateDesktopPlayIcon);
    modalVideo.addEventListener('pause', updateDesktopPlayIcon);
  }

  if (modalProgress) {
    modalProgress.addEventListener('click', function(e) {
      var r = modalProgress.getBoundingClientRect();
      if (modalVideo) {
        modalVideo.currentTime = ((e.clientX - r.left) / r.width) * (modalVideo.duration || 0);
      }
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  /* ===== MOBILE STACK ===== */
  function buildMobileStack(startIdx) {
    if (modalStack) modalStack.innerHTML = '';
    mSlides = [];
    if (mRafProg) { cancelAnimationFrame(mRafProg); mRafProg = null; }
    mReelIndex = ((startIdx % total) + total) % total;

    var indices = [
      (mReelIndex - 1 + total) % total,
      mReelIndex,
      (mReelIndex + 1) % total
    ];

    indices.forEach(function(dataIdx, pos) {
      var slide = document.createElement('div');
      slide.className = 'reel-modal__slide';
      slide.style.cssText = 'position:absolute;left:0;right:0;height:100%;top:' + ((pos - 1) * 100) + '%;transition:none;';

      var v = document.createElement('video');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('x-webkit-airplay', 'deny');
      v.loop    = true;
      v.muted   = globalMuted;
      v.preload = 'auto';
      v.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;transform:translateZ(0);';

      /* Android loop fallback */
      v.addEventListener('ended', function() {
        v.currentTime = 0;
        v.play().catch(function() {});
      });

      var gradBot = document.createElement('div');
      gradBot.className = 'reel-modal__grad-bot';

      var meta = document.createElement('div');
      meta.className = 'reel-modal__meta';
      meta.innerHTML =
        '<span class="reel-modal__meta-tag">'  + (reelData[dataIdx].tag   || '') + '</span>' +
        '<div class="reel-modal__meta-title">' + (reelData[dataIdx].title || '') + '</div>' +
        '<div class="reel-modal__meta-sub">'   + (reelData[dataIdx].sub   || '') + '</div>';

      var prog = document.createElement('div');
      prog.className = 'reel-modal__progress';
      var fill = document.createElement('div');
      fill.className = 'reel-modal__progress-fill';
      prog.appendChild(fill);
      prog.addEventListener('click', function(e) {
        var r = prog.getBoundingClientRect();
        v.currentTime = ((e.clientX - r.left) / r.width) * (v.duration || 0);
      });

      slide.appendChild(v);
      slide.appendChild(gradBot);
      slide.appendChild(meta);
      slide.appendChild(prog);
      if (modalStack) modalStack.appendChild(slide);
      mSlides.push({ el: slide, video: v, fill: fill, dataIdx: dataIdx });

      v.src = reelData[dataIdx].src;
      v.load();
    });

    /* Play center slide */
    var center = mSlides[1];
    if (center && center.video) {
      center.video.addEventListener('canplay', function onCan() {
        center.video.removeEventListener('canplay', onCan);
        center.video.play().catch(function() {});
        if (modalPlayIcon) modalPlayIcon.innerHTML = SVG_PAUSE;
      }, { once: true });
      if (mSlides[0] && mSlides[0].video) mSlides[0].video.load();
      if (mSlides[2] && mSlides[2].video) mSlides[2].video.load();
      tickMobileProg(center.video, center.fill);
    }
    if (modalMuteIcon) modalMuteIcon.innerHTML = globalMuted ? SVG_VOL_OFF : SVG_VOL_ON;
  }

  function tickMobileProg(video, fill) {
    if (mRafProg) cancelAnimationFrame(mRafProg);
    (function step() {
      if (fill && !video.paused && video.duration) {
        fill.style.width = (video.currentTime / video.duration * 100) + '%';
      }
      mRafProg = requestAnimationFrame(step);
    })();
  }

  function mobileNavigate(direction) {
    var nextIdx = direction === 'up'
      ? (mReelIndex + 1) % total
      : (mReelIndex - 1 + total) % total;

    mSlides.forEach(function(s, i) {
      var offset = direction === 'up' ? -1 : 1;
      s.el.style.transition = 'top 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      s.el.style.top = ((i - 1 + offset) * 100) + '%';
    });

    setTimeout(function() {
      mSlides.forEach(function(s) {
        if (s.video) { s.video.pause(); s.video.currentTime = 0; }
      });
      buildMobileStack(nextIdx);
    }, 370);
  }

  /* ===== MOBILE MODAL TOUCH ===== */
  if (modalInner) {
    modalInner.addEventListener('touchstart', function(e) {
      mTouchY0  = e.touches[0].clientY;
      mTouchX0  = e.touches[0].clientX;
      mSwiping  = false;
      mSwipeDir = null;
    }, { passive: true });

    modalInner.addEventListener('touchmove', function(e) {
      if (!isMobile()) return;
      var dy = e.touches[0].clientY - mTouchY0;
      var dx = e.touches[0].clientX - mTouchX0;
      if (!mSwipeDir) { mSwipeDir = Math.abs(dy) > Math.abs(dx) ? 'v' : 'h'; }
      if (mSwipeDir === 'v') {
        e.preventDefault();
        mSwiping = true;
        mSlides.forEach(function(s, i) {
          s.el.style.transition = 'none';
          s.el.style.top = 'calc(' + ((i - 1) * 100) + '% + ' + dy + 'px)';
        });
      }
    }, { passive: false });

    modalInner.addEventListener('touchend', function(e) {
      if (!isMobile() || !mSwiping) return;
      mSwiping = false;
      var dy = e.changedTouches[0].clientY - mTouchY0;
      if (Math.abs(dy) > 70) {
        mobileNavigate(dy < 0 ? 'up' : 'down');
      } else {
        /* Snap back */
        mSlides.forEach(function(s, i) {
          s.el.style.transition = 'top 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
          s.el.style.top = ((i - 1) * 100) + '%';
        });
      }
    }, { passive: true });
  }

  /* ===== INTERSECTION OBSERVER ===== */
if ('IntersectionObserver' in window) {
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      sectionVisible = entry.isIntersecting;
      if (entry.isIntersecting) {
        autoPlayVisible();
      } else {
        realCards.forEach(function(card) {
          var v = card.querySelector('.reel-card__video');
          if (v && !v.paused) { v.pause(); v.src = ''; v.removeAttribute('data-loaded'); }
        });
      }
    });
  }, { threshold: 0.1, rootMargin: '200px' });
  var section = document.getElementById('reel-carousel-section');
  if (section) obs.observe(section);
}

  /* ===== RESIZE ===== */
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      measure();
      renderDots();
      goTo(currentPage, false);
    }, 150);
  });

  /* ===== INIT ===== */
  buildClones();
  refreshAllCards();
  measure();
  renderDots();
  goTo(0, false);

})();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initReelCarousel);
} else {
  initReelCarousel();
}

document.addEventListener('shopify:section:load', function(e) {
  if (e.target && e.target.querySelector('#reel-carousel-section')) {
    initReelCarousel();
  }
});